import { render } from "./YouVsApp.vue?vue&type=template&id=4d217fba&scoped=true"
import script from "./YouVsApp.vue?vue&type=script&lang=js"
export * from "./YouVsApp.vue?vue&type=script&lang=js"

import "./YouVsApp.vue?vue&type=style&index=0&id=4d217fba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d217fba"]])

export default __exports__